"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var axios_1 = __importDefault(require("axios"));
exports.default = vue_1.default.extend({
    data: function () {
        return {
            cache: [],
        };
    },
    computed: {
        URL: function () {
            return 'https://yubinbango.github.io/yubinbango-data/data';
        },
        REGIONS: function () {
            return [
                '', '北海道', '青森県', '岩手県', '宮城県',
                '秋田県', '山形県', '福島県', '茨城県', '栃木県',
                '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県',
                '新潟県', '富山県', '石川県', '福井県', '山梨県',
                '長野県', '岐阜県', '静岡県', '愛知県', '三重県',
                '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県',
                '和歌山県', '鳥取県', '島根県', '岡山県', '広島県',
                '山口県', '徳島県', '香川県', '愛媛県', '高知県',
                '福岡県', '佐賀県', '長崎県', '熊本県', '大分県',
                '宮崎県', '鹿児島県', '沖縄県'
            ];
        }
    },
    methods: {
        resolvePostCode: function (inputVal) {
            var _this = this;
            if (inputVal === void 0) { inputVal = ''; }
            // 全角の数字を半角に変換 ハイフンが入っていても数字のみの抽出
            var a = inputVal.replace(/[０-９]/g, function (s) { return String.fromCharCode(s.charCodeAt(0) - 65248); });
            var b = a.match(/\d/g);
            var c = b === null || b === void 0 ? void 0 : b.join('');
            var yubin7 = c && this.chk7(c);
            // 7桁の数字の時のみ作動
            return new Promise(function (resolve) {
                if (yubin7) {
                    _this.getAddr(yubin7).then(function (result) {
                        resolve(result);
                    });
                }
                else {
                    resolve(_this.addrDic());
                }
            });
        },
        chk7: function (val) {
            if (val.length === 7) {
                return val;
            }
        },
        addrDic: function (region_id, region, locality, street, extended) {
            if (region_id === void 0) { region_id = ''; }
            if (region === void 0) { region = ''; }
            if (locality === void 0) { locality = ''; }
            if (street === void 0) { street = ''; }
            if (extended === void 0) { extended = ''; }
            return {
                region_id: region_id,
                region: region,
                locality: locality,
                street: street,
                extended: extended
            };
        },
        selectAddr: function (addr) {
            if (addr && addr[0] && addr[1]) {
                return this.addrDic(addr[0], this.REGIONS[parseInt(addr[0])], addr[1], addr[2], addr[3]);
            }
            else {
                return this.addrDic();
            }
        },
        jsonp: function (url) {
            return axios_1.default.get(url).then(function (result) {
                var text = result.data.replace(/^\$yubin\(/, '').replace(/\);/, '');
                return JSON.parse(text);
            });
        },
        getAddr: function (yubin7) {
            var _this = this;
            var yubin3 = yubin7.substr(0, 3);
            // 郵便番号上位3桁でキャッシュデータを確認
            if (yubin3 in this.cache && yubin7 in this.cache[yubin3]) {
                return new Promise(function (resolve) {
                    resolve(_this.selectAddr(_this.cache[yubin3][yubin7]));
                });
            }
            else {
                return new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
                    var data;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.jsonp(this.URL + "/" + yubin3 + ".js")];
                            case 1:
                                data = _a.sent();
                                this.cache[yubin3] = data;
                                resolve(this.selectAddr(data[yubin7]));
                                return [2 /*return*/];
                        }
                    });
                }); });
            }
        }
    }
});
